"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDigest = exports.validateDigest = void 0;
const regexp_1 = require("./regexp");
class InvalidDigestFormatError extends Error {
    constructor() {
        super('invalid digest format');
        this.name = 'InvalidDigestFormatError';
    }
}
class UnsupportedAlgorithmError extends Error {
    constructor() {
        super('unsupported digest algorithm');
        this.name = 'UnsupportedAlgorithmError';
    }
}
class InvalidDigestLengthError extends Error {
    constructor() {
        super('invalid checksum digest length');
        this.name = 'InvalidDigestLengthError';
    }
}
const algorithmsSizes = {
    sha256: 32,
    sha384: 48,
    sha512: 64,
};
function checkDigest(digest, handleError) {
    const indexOfColon = digest.indexOf(':');
    if (indexOfColon < 0 ||
        indexOfColon + 1 === digest.length ||
        !regexp_1.anchoredDigestRegexp.test(digest)) {
        return handleError(InvalidDigestFormatError);
    }
    const algorithm = digest.substring(0, indexOfColon);
    if (!Object.hasOwnProperty.call(algorithmsSizes, algorithm)) {
        return handleError(UnsupportedAlgorithmError);
    }
    if (algorithmsSizes[algorithm] * 2 !== (digest.length - indexOfColon - 1)) {
        return handleError(InvalidDigestLengthError);
    }
    return true;
}
const validateDigest = (digest) => {
    checkDigest(digest, (ErrorType) => {
        throw new ErrorType();
    });
};
exports.validateDigest = validateDigest;
const isDigest = (digest) => {
    return checkDigest(digest, () => false);
};
exports.isDigest = isDigest;
//# sourceMappingURL=digest.js.map